import {
    IconButton,
    Tooltip
} from '@chakra-ui/react'
import { FiInfo } from 'react-icons/fi'

export const InfoPopover = ({ helperText, ...props }) => {
    return (
        <Tooltip label={helperText}>
            <IconButton
               tabIndex='-1'
               isRound
               aria-label="Info"
               {...props}
               variant=''
               color='var(--chakra-colors-help-icons)'
               icon={<FiInfo strokeWidth={3}/>}
               height="1em"
               minWidth="1.75em"
               />
        </Tooltip>
    )
}
